export enum DateFormatType {
  DdMm = 'ddmm',
  MmDd = 'mmdd',
}
